import { Component } from '@angular/core';

import { PortalService } from '@auth/services/portal.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'sume-home-footer',
    templateUrl: './home-footer.component.html',
    styleUrls: ['./home-footer.component.scss'],
})
export class HomeFooterComponent {
    dt = new Date();
    is_dev = !environment.production;

    constructor(public portalService: PortalService) {}
}
